export default () => {
  const options = (config = {}, defaultLines = 1) => {
    let numberOfLines = defaultLines;
    const breakpoints = Object.keys(config).map((width) => parseInt(width, 10));
    const windowWidth = $(window).width();
    breakpoints.forEach((breakpoint) => {
      numberOfLines = (breakpoint <= windowWidth) ? config[breakpoint] : numberOfLines;
    });
    return { lines: numberOfLines };
  };
  const truncate = () => {
    $('.card-carousel h4').trunk8(options({ 320: 2, 840: 3, 1025: 3, 1280: 2 }));
  };

  $(window).on('resize', truncate).trigger('resize');
};
